export default __webpack_public_path__ + "static/media/fit-tracking.5809ff83.png";